<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'NonConformityOrigins/Get/'}"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'NonConformityOriginIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'NonConformityOrigin' */ './ModalNew')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
